/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usersColumns } from "../../Data/UsersListData";
import CustomTable from "../../../../Core/Components/CustomTable";
import UserIcon from "../../../../Common/Svgs/UserIcon";
import { getAllDrivers, getDriversV3 } from "../../../../Redux/APIs/usersAPI";
import { getUserByEmail } from "../../../../Redux/APIs/systemUsersAPI";
import DriverHeader from "./DriverHeader";
import DeleteDriverModal from "./DeleteDriverModal";
import { updateUsers } from "../../../../Redux/Slices/users.slice";
import useDebounce from "../../../../Core/hooks/useDebounce";
import ViewDetailsDrawer from "./ViewDetailsDrawer";
import { getTableContainerHeight } from "../../../../Utils/getTableContainerHeight";
import { getAllLocationsV3 } from "../../../../Redux/APIs/locationsAPI";
import DriverDetailDrawer from "./DriverDetailDrawer";
import ViewLicenseModal from "../ViewLicenseModal";
import ToastMessageModal from "../../../Settings/ToastMessageModal";
import { updateLoggedInUser } from "../../../../Redux/Slices/loggedInUser.slice";
import DriverFeedbackModal from "./DriverFeedbackModal";
import { updateTrips } from "../../../../Redux/Slices/trips.slice";
import DriverFeedbackDrawer from "./DriverFeedbackDrawer";
import CustomPagination from "../../../../Core/Components/CustomPagination";
import DriverRequestDrawer from "./DriverRequestDrawer";

const LOCAL_DEFAULT_LIMIT = 10;

const DriversList = () => {
  const dispatch = useDispatch();

  const {
    driversListV3,
    deleteDriverModal,
    tripDetailsDrawer,
    driverDetailDrawer,
    licenseModal,
    driverFeedbackDrawer,
    driverRequestDrawer,
  } = useSelector((state) => state.users);

  const { driverRatingModal } = useSelector((state) => state.trips);

  const { userDetails, toastMessageModal } = useSelector(
    (state) => state.loggedInUser,
  );

  const tableContainerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    hub: [],
    currentTrike: [],
    driverDateRangeStart: "",
    driverDateRangeEnd: "",
    addedBy: [],
  });

  const debounceSearch = useDebounce(search, 500);

  const onPageClose = () => {
    dispatch(
      updateUsers({
        key: "tripDetailsDrawer",
        value: {
          visible: false,
          driverName: "",
        },
      }),
    );

    dispatch(
      updateUsers({
        key: "driverDetailDrawer",
        value: { visible: false, data: {} },
      }),
    );
  };

  // clear the toast message
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateLoggedInUser({
          key: "toastMessageModal",
          value: { visible: false, title: "", description: "" },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, toastMessageModal]);

  // fetch drivers (pagination based) along with the filters
  useEffect(() => {
    const filterObj = {
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      limit: LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) {
      filterObj.offset = 0;
      filterObj.searchQuery = debounceSearch;
    }

    if (filters.hub.length) {
      filterObj.hub = filters.hub;
    }

    if (filters.currentTrike.length) {
      filterObj.currentTrike = filters.currentTrike;
    }

    if (filters.addedBy.length) {
      filterObj.addedBy = filters.addedBy.map((user) => user.id);
    }

    if (
      filters.driverDateRangeStart !== "" &&
      filters.driverDateRangeEnd !== ""
    ) {
      filterObj.dateRangeStart = filters.driverDateRangeStart;
      filterObj.dateRangeEnd = filters.driverDateRangeEnd;
    }

    dispatch(getDriversV3(filterObj));
  }, [dispatch, currentPage, filters, debounceSearch]);

  // fetch user details and all the locations (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
    // dispatch(getAllLocationsV3());
    dispatch(getAllDrivers());

    setTimeout(() => {
      dispatch(getAllLocationsV3());
    }, 3000);

    return () => {
      onPageClose();
    };
  }, [dispatch]);

  return (
    <div>
      <DriverHeader
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
      />

      <div
        className={`h-[calc(100vh-72px-71px-69px-40px)] ${
          driversListV3.result.length && "overflow-y-scroll"
        }`}
        ref={tableContainerRef}
      >
        <CustomTable
          // scrollX={0}
          // scrollY="446px"
          disableScroll
          columns={usersColumns}
          data={driversListV3.result}
          emptyState={
            <UserIcon className="w-4 h-4 fill-none stroke-dark-grey-text" />
          }
          emptyStateHeight={getTableContainerHeight(tableContainerRef)}
          rowClassName="group"
          pagination={{
            pageSize: LOCAL_DEFAULT_LIMIT,
            total: driversListV3.totalRecords,
            showSizeChanger: false,
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
            itemRender: (current, type, originalElement) => {
              return (
                <CustomPagination
                  type={type}
                  current={current}
                  originalElement={originalElement}
                  totalRecords={Number(driversListV3?.totalRecords || 0)}
                />
              );
            },
            // itemRender: (current, type, originalElement) => {
            //   const lastPage = driversListV3.totalRecords / current;

            //   if (type === "prev" && current === 0) {
            //     return (
            //       <button
            //         type="button"
            //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
            //         style={{
            //           pointerEvents: "none",
            //         }}
            //       >
            //         <ChevronIcon className="stroke-dark-gray" />
            //       </button>
            //     );
            //   }

            //   if (type === "prev" && current > 0) {
            //     return (
            //       <button
            //         type="button"
            //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
            //       >
            //         <ChevronIcon className="stroke-dark-gray" />
            //       </button>
            //     );
            //   }

            //   if (type === "next" && lastPage <= 10) {
            //     return (
            //       <button
            //         type="button"
            //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
            //         style={{ pointerEvents: "none" }}
            //       >
            //         <ChevronIcon className="stroke-dark-gray" />
            //       </button>
            //     );
            //   }

            //   if (type === "next") {
            //     return (
            //       <button
            //         type="button"
            //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
            //       >
            //         <ChevronIcon className="stroke-dark-gray" />
            //       </button>
            //     );
            //   }

            //   return originalElement;
            // },
          }}
        />
      </div>

      <div>
        <ViewDetailsDrawer
          visible={tripDetailsDrawer.visible}
          onCancel={() =>
            dispatch(
              updateUsers({
                key: "tripDetailsDrawer",
                value: {
                  visible: false,
                  driverName: "",
                },
              }),
            )
          }
        />
      </div>

      <DeleteDriverModal
        visible={deleteDriverModal.visible}
        onCancel={() => {
          dispatch(
            updateUsers({
              key: "deleteDriverModal",
              value: {
                visible: false,
                id: 0,
              },
            }),
          );

          dispatch(
            updateUsers({
              key: "driverUpcomingTrips",
              value: [],
            }),
          );
        }}
        driversCurrentPage={currentPage}
        setDriversCurrentPage={setCurrentPage}
      />

      <DriverDetailDrawer
        visible={driverDetailDrawer?.visible}
        onCancel={() =>
          dispatch(
            updateUsers({
              key: "driverDetailDrawer",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <ToastMessageModal
        visible={toastMessageModal?.visible}
        onCancel={() =>
          dispatch(
            updateLoggedInUser({
              key: "toastMessageModal",
              value: { ...toastMessageModal, visible: false },
            }),
          )
        }
      />
      <ViewLicenseModal
        visible={licenseModal?.visible}
        onCancel={() =>
          dispatch(
            updateUsers({
              key: "licenseModal",
              value: {
                visible: false,
                url: "",
              },
            }),
          )
        }
      />

      <DriverFeedbackModal
        visible={driverRatingModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "driverRatingModal",
              value: { visible: false, tripId: 0, driverId: 0, driverName: "" },
            }),
          )
        }
      />

      <DriverFeedbackDrawer
        visible={driverFeedbackDrawer?.visible}
        onCancel={() =>
          dispatch(
            updateUsers({
              key: "driverFeedbackDrawer",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <DriverRequestDrawer
        visible={driverRequestDrawer?.visible}
        onCancel={() =>
          dispatch(
            updateUsers({
              key: "driverRequestDrawer",
              value: { visible: false, data: {} },
            }),
          )
        }
      />
    </div>
  );
};

export default DriversList;
